import { RESET, SET_DETAILS, SET_SIMILAR_DATA, SET_OWNERS, SET_FIELD_VALUE, SET_STATUSES, SET_OPPORT_TYPES } from './actionTypes';
import { mapToStore } from './utils';

const initialState = {
  ownerId: '',
  owners: [],
  opportunityName: '',
  withoutNewOpportunity: false,
  accountStatusId: '',
  accountStatuses: [],
  createAccountName: '',
  createAccountNameId: 0,
  similarAccounts: [],
  opportunityTypes: [],
  opportunityId: '',
};

const getDefaultPickList = (pickList) => {
  let defaultValue = '';
  if (!_.isEmpty(pickList)) {
    const defaultItem = pickList.filter(list => list.is_default);
    if (!_.isEmpty(defaultItem)) {
      defaultValue = defaultItem[0].option_value;
    } else {
      defaultValue = pickList[0].option_value;
    }
  }
  return defaultValue;
};

const convertDetails = (state = initialState, action) => {
  switch (action.type) {
    case SET_DETAILS:
      const { details } = action.payload;
      const mappedData = mapToStore(details);
      return {
        ...state,
        ...mappedData,
      };


    case SET_OWNERS:
      const { owners } = action.payload;
      return {
        ...state,
        owners,
      };


    case SET_SIMILAR_DATA:
      const { similarAccounts } = action.payload;
      return {
        ...state,
        similarAccounts,
      };


    case SET_FIELD_VALUE:
      const { name, value, extraValue } = action.payload;
      if (name === 'createAccountNameId') {
        return {
          ...state,
          createAccountNameId: value,
          createAccountName: extraValue,
        };
      }
      return {
        ...state,
        [name]: value,
      };


    case SET_STATUSES:
      const { accountStatuses } = action.payload;
      const accountStatusId = _.isArray(accountStatuses) ? getDefaultPickList(accountStatuses) : '';
      return {
        ...state,
        accountStatuses,
        accountStatusId,
      };

    case SET_OPPORT_TYPES:
      const { opportunityTypes } = action.payload;
      const opportunityId = _.isArray(opportunityTypes) ? getDefaultPickList(opportunityTypes) : '';
      return {
        ...state,
        opportunityTypes,
        opportunityId,
      };

    case RESET:
      return initialState;


    default:
      return state;
  }
};

export default convertDetails;



// WEBPACK FOOTER //
// ./src/components/page/ConvertDetails/flow/reducer.js